import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-calendar-container d-flex justify-content-around" }
const _hoisted_2 = {
  id: "date-picker-date-1",
  class: ""
}
const _hoisted_3 = {
  id: "date-picker-date-2",
  class: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"row\"><div class=\"col-1 m-0\"></div><div class=\"col-11 m-0 position-relative input-col-10-padding\" data-bs-toggle=\"modal\" data-bs-target=\"#picker-frequency\"><input class=\"custom-select-frequency\" id=\"picker-frequency-date\" placeholder=\"Pasirinkite kelionės dažnumą\"><div class=\"arrow-select position-absolute icon-calender-position\"><img src=\"/assets/images/calendar-calendar-1.svg\"></div></div></div>", 1)),
    _createVNode(_component_ModalComponent, {
      "id-data": 'picker-frequency',
      "modal-title": 'Pasirinkite kelionės dažnumą'
    }, {
      "body-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.date1,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date1) = $event)),
              enableTimePicker: false,
              monthNameFormat: "long",
              locale: _ctx.store.state.general.locale,
              inline: "",
              autoApply: "",
              id: "picker-1",
              ref: "datepicker-1"
            }, null, 8, ["modelValue", "locale"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.date2,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date2) = $event)),
              enableTimePicker: false,
              monthNameFormat: "long",
              locale: _ctx.store.state.general.locale,
              inline: "",
              autoApply: "",
              id: "picker-2",
              ref: "datepicker-2"
            }, null, 8, ["modelValue", "locale"])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}